import React from 'react'
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import FetchUtil from "../../../util/FetchUtil";
import ConfigUtil from "../../../util/ConfigUtil";
import PropTypes from "prop-types";

const INITAL_STATE = {
};

class UserSearch extends React.Component {

    constructor(props) {
        super(props);

        this.state = {...INITAL_STATE, username: props.username ? props.username : ""};
    }

    handelKeyDown(e) {
        if (e.keyCode === 13) {
            // enter
            this.searchUser();
        }
    }

    searchUser() {
        this.props.callBackClearMessages();
        let username = this.state.username;
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.user + "/searchusername?username=" + username,
            {},
            json => {
                if( json === null || json === undefined || json === "" ) {
                    this.props.callBackError("Kein User zum Usernamen '" + username + "' gefunden!");
                } else {
                    this.props.callBackUserFound(json);
                    this.setState({userGefunden: true});
                }
            },
            responseNotOk => {
                this.props.callBackError("Fehler beim Suchen eines Users: " + responseNotOk.message);
            },
            error => {
                this.props.callBackError("Fehler beim Suchen eines Users: " + error.message);
            }
        );
    }

    resetSearch() {
        this.setState({userGefunden:false, username: ""});
        this.props.callBackUserFound(undefined);
    }
    changeUsername(value) {
        this.setState({username:value, userGefunden:false, user: undefined});
    }

    render() {
        return <div>
            <div className="grid">
                <div className="col-fixed" style={{width:150}}>
                    <InputText style={{width:"100%"}} value={this.state.username}
                               onKeyDown={(e) => this.handelKeyDown(e)}
                               onChange={(e) => this.changeUsername(e.target.value)}
                    disabled={this.state.userGefunden}/></div>
                {this.state.userGefunden && <>
                    <div className="col-fixed" style={{width: 40}}>
                        <img src="images/found.png" alt="User wurde gefunden" style={{width: 30}}/>
                    </div>
                    <div className="col-fixed" style={{width:40}}>
                        <Button icon="pi pi-times" onClick={() => this.resetSearch()}
                                style={{marginLeft: 5}}/>
                    </div>
                    </>
                }
                {!this.state.userGefunden &&
                    <div className="col-fixed" style={{width: this.props.shortSearchButton ? 35: 120}}>
                        <Button label={this.props.shortSearchButton ? "" : "Suchen"} disabled={!this.state.username} icon="pi pi-search" onClick={() => this.searchUser()} />
                    </div>
                }
            </div>
        </div>
    }
}

UserSearch.propTypes = {
    username: PropTypes.string,
    callBackError: PropTypes.func.isRequired,
    callBackClearMessages: PropTypes.func.isRequired,
    callBackUserFound: PropTypes.func.isRequired,
    shortSearchButton: PropTypes.bool,
};

export default UserSearch
